module.exports = __webpack_public_path__ + "static/media/Xero-offline.9bfa79b1.png";